module.exports = __webpack_public_path__ + "img/Vega-Icons.7ae30e0c.svg";